  import React, { Suspense, lazy } from 'react';
  import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
  import './i18n';  // ✅ 초기화가 앱 시작 시점에 실행되도록
  import Loading from './components/other/Loding.js';
  import LoginPage from './pages/LoginPage.js';
  //bootstrap css
  import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './context/AuthContext.js';
import ProtectedRoute from './context/ProtectedRoute.js';
import { STAGE_DAM_KEYS, getDamData } from './config/damData.js';

const MainPage = lazy(() => import('./pages/MainPage.js'));
const YeongjuPage = lazy(() => import('./pages/YeongjuPage.js'));
const Error = lazy(() => import('./components/other/Errorpage.js'));
const CompareSatellitePage = lazy(() => import('./pages/CompareSatellitePage.js'));
const CompareDronePage = lazy(() => import('./pages/CompareDronePage.js'));
const SwipePage = lazy(() => import('./pages/SwipePage.js'));
const PointCloudPage = lazy(() => import('./pages/PointCloudPage.js'));
const SignUpPage = lazy(() => import('./pages/SignUpPage.js'));
const Chartinfopage = lazy(() => import('./pages/ChartInfoPage.js'));
const ManagerPage = lazy(() => import('./pages/AdminPage/ManagerPage.js'));
const DemoPage = lazy(() => import('./pages/DemoPage.js'));
const CropDataPage = lazy(() => import('./pages/testpage.js'));
const FourSyncMaps = lazy(() => import('./pages/ShareView.js'));
const DaecheongPage = lazy(() => import('./pages/DaecheongPage.js'));
const BohyeonsanPage = lazy(() => import('./pages/BohyeonsanPage.js'));
const YongdamPage = lazy(() => import('./pages/YongdamPage.js'));
const Stage2DamPage = lazy(() => import('./pages/Stage2DamPage.js'));







function App() {



  return (
    <AuthProvider>
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
      <Routes>
       
        {/* ✅ 로그인 페이지 */}
        <Route path="/" element={<LoginPage />} />

        {/* ✅ 회원가입 페이지 */}
        <Route path="/SignUpPage" element={<SignUpPage />} />

        {/* ✅ 보호된 페이지들 */}
        <Route
          path="/MainPage"
          element={
            <ProtectedRoute>
              <MainPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/loding"
          element={
            <ProtectedRoute >
              <Loading />
            </ProtectedRoute>
          }
        />
        <Route
          path="/error"
          element={
            <ProtectedRoute >
              <Error />
            </ProtectedRoute>
          }
        />
        <Route
          path="/YeongjuPage"
          element={
            <ProtectedRoute >
              <YeongjuPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/DaecheongPage"
          element={
            <ProtectedRoute >
              <DaecheongPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/BohyeonsanPage"
          element={
            <ProtectedRoute >
              <BohyeonsanPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/YongdamPage"
          element={
            <ProtectedRoute >
              <YongdamPage />
            </ProtectedRoute>
          }
        />
        {/* ✅ 2·3단계 확장 댐: config/damData.js 의 enabled 값으로 오픈 여부 결정.
            새 댐을 열 때는 damData.js 의 enabled 만 true 로 바꾸면 되고, 이 파일은 건드릴 필요 없다. */}
        {STAGE_DAM_KEYS.map((damKey) => (
          <Route
            key={damKey}
            path={`/${damKey}Page`}
            element={
              <ProtectedRoute>
                {getDamData(damKey).enabled ? (
                  <Stage2DamPage damKey={damKey} />
                ) : (
                  <Error />
                )}
              </ProtectedRoute>
            }
          />
        ))}
        <Route
          path="/CompareSatellitePage"
          element={
            <ProtectedRoute >
              <CompareSatellitePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/FourSyncMaps"
          element={
            <ProtectedRoute >
              <FourSyncMaps />
            </ProtectedRoute>
          }
        />
        <Route
          path="/CompareDronePage"
          element={
            <ProtectedRoute >
              <CompareDronePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/SwipePage"
          element={
            <ProtectedRoute >
              <SwipePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pointcloud"
          element={
            <ProtectedRoute >
              <PointCloudPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chartinfopage"
          element={
            <ProtectedRoute >
              <Chartinfopage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/managerpage"
          element={
            <ProtectedRoute >
              <ManagerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Demopage"
          element={
            <ProtectedRoute >
              <DemoPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/testpage"
          element={
            <ProtectedRoute >
              <CropDataPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      </Suspense>
    </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
